<div class="form-group mx-md-1 mx-3 my-4 my-md-2">
  <label>{{ "LAYERMANAGER.layerEditor.opacity" | translateHs }}</label>
  <input type="range" name="layer-opacity" step="0.01" min="0" max="1" style="width: 100%; height: 21px"
    [(ngModel)]="opacity" />
</div>